import { render } from "./ConfigurationOptionsItemChoice.vue?vue&type=template&id=0945a095&scoped=true"
import script from "./ConfigurationOptionsItemChoice.vue?vue&type=script&lang=js"
export * from "./ConfigurationOptionsItemChoice.vue?vue&type=script&lang=js"

import "./ConfigurationOptionsItemChoice.vue?vue&type=style&index=0&id=0945a095&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0945a095"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QBtn});
